import React from 'react';
export function Footer() {
  return <footer className="w-full py-8 px-6 md:px-12 bg-[var(--color-dark)]" data-id="element-128">
      <div className="max-w-7xl mx-auto" data-id="element-129">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6" data-id="element-130">
          {/* Logo */}
          <div className="flex items-center" data-id="element-131">
            <img src="https://cdn.magicpatterns.com/uploads/4nkahh2hNsVZTnNq46Gbps/elvora_logo_cutout.png" alt="ELVORA" className="h-8 w-auto brightness-0 invert" data-id="element-132" />
          </div>

          {/* Navigation - Pages */}
          <nav className="flex flex-wrap items-center justify-center gap-2" data-id="element-133">
            <a href="/specialists" className="px-4 py-2 text-sm font-medium text-white rounded-full border border-gray-600 hover:border-gray-500 transition-colors text-center" data-id="element-134">
              For Seafarers
            </a>
            <a href="/companies" className="px-4 py-2 text-sm font-medium text-white rounded-full border border-gray-600 hover:border-gray-500 transition-colors text-center" data-id="element-135">
              For Companies
            </a>
          </nav>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-3 w-full md:w-auto" data-id="element-136">
            <button className="px-5 py-2.5 bg-[var(--color-tan)] text-white text-sm font-medium rounded-lg hover:opacity-90 transition-opacity" data-id="element-137">
              Discuss Your Task
            </button>
            <button className="px-5 py-2.5 bg-[var(--color-tan)] text-white text-sm font-medium rounded-lg hover:opacity-90 transition-opacity" data-id="element-138">
              Send Your Profile
            </button>
          </div>
        </div>

        {/* Divider */}
        <div className="my-6 border-t border-gray-700" data-id="element-139"></div>

        {/* Social Links */}
        <div className="flex flex-wrap justify-center gap-4 mb-6" data-id="element-140">
          <a href="https://t.me/elvora" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 text-gray-400 hover:text-white transition-colors" data-id="element-141">
            <svg className="w-5 h-5" viewBox="0 0 24 24" fill="currentColor" data-id="element-142">
              <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm4.64 6.8c-.15 1.58-.8 5.42-1.13 7.19-.14.75-.42 1-.68 1.03-.58.05-1.02-.38-1.58-.75-.88-.58-1.38-.94-2.23-1.5-.99-.65-.35-1.01.22-1.59.15-.15 2.71-2.48 2.76-2.69a.2.2 0 00-.05-.18c-.06-.05-.14-.03-.21-.02-.09.02-1.49.95-4.22 2.79-.4.27-.76.41-1.08.4-.36-.01-1.04-.2-1.55-.37-.63-.2-1.12-.31-1.08-.66.02-.18.27-.36.74-.55 2.92-1.27 4.86-2.11 5.83-2.51 2.78-1.16 3.35-1.36 3.73-1.36.08 0 .27.02.39.12.1.08.13.19.14.27-.01.06.01.24 0 .38z" data-id="element-143" />
            </svg>
            <span className="text-sm" data-id="element-144">Telegram</span>
          </a>
          <a href="viber://chat?number=+380" className="flex items-center gap-2 text-gray-400 hover:text-white transition-colors" data-id="element-145">
            <svg className="w-5 h-5" viewBox="0 0 24 24" fill="currentColor" data-id="element-146">
              <path d="M11.398 0c-2.05.027-6.547.362-9.08 2.66C.88 4.6.2 7.333.13 10.732c-.07 3.398-.16 9.764 5.998 11.475h.004l-.004 2.82s-.04 1.042.65 1.256c.83.258 1.316-.534 2.11-1.39.434-.47 1.035-1.156 1.49-1.685 4.105.345 7.26-.444 7.627-.56.827-.27 5.52-.872 6.283-7.098.788-6.418-.383-10.48-2.495-12.308C21.14.586 18.508-.245 11.398 0z" data-id="element-147" />
            </svg>
            <span className="text-sm" data-id="element-148">Viber</span>
          </a>
          <a href="https://wa.me/380" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 text-gray-400 hover:text-white transition-colors" data-id="element-149">
            <svg className="w-5 h-5" viewBox="0 0 24 24" fill="currentColor" data-id="element-150">
              <path d="M12.04 2c-5.46 0-9.91 4.45-9.91 9.91 0 1.75.46 3.45 1.32 4.95L2.05 22l5.25-1.38c1.45.79 3.08 1.21 4.74 1.21 5.46 0 9.91-4.45 9.91-9.91 0-2.65-1.03-5.14-2.9-7.01A9.816 9.816 0 0012.04 2z" data-id="element-151" />
            </svg>
            <span className="text-sm" data-id="element-152">WhatsApp</span>
          </a>
          <a href="mailto:info@elvora.com" className="flex items-center gap-2 text-gray-400 hover:text-white transition-colors" data-id="element-153">
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-154">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" data-id="element-155" />
            </svg>
            <span className="text-sm" data-id="element-156">Email</span>
          </a>
        </div>

        {/* Bottom row */}
        <div className="flex flex-col md:flex-row items-center justify-between gap-4 text-center" data-id="element-157">
          <p className="text-sm text-gray-500" data-id="element-158">© ELVORA</p>
          <div className="flex gap-4 text-sm text-gray-500" data-id="element-159">
            <a href="#" className="hover:text-gray-400 transition-colors" data-id="element-160">
              Privacy Policy
            </a>
            <span data-id="element-161">|</span>
            <a href="#" className="hover:text-gray-400 transition-colors" data-id="element-162">
              Terms of Use
            </a>
          </div>
        </div>
      </div>
    </footer>;
}